<template>
    <div>
        <div class="top_banner">
            <div class="top_banner_text">
                <p>电子政务</p>
                <!--<p>News</p>-->
            </div>
        </div>
        <div class="about_us_bg">
            <div class="w_1200 w_1200_boot non_margin">
                <div class="about_us">
                    <div class="about_tap clearfix">
                        <a href="" class="on">电子政务</a>
                        <a href="">电子商务</a>
                        <a href="">保险信贷</a>
                        <a href="">旅游行业</a>
                        <a href="">房屋租赁</a>
                    </div>
                    <!--解决方案-->
                    <div class="solution_box">
                        <h6 class="solution_title">行业痛点</h6>
                        <p class="solution_intro">

                        </p>
                        <div class="solution_pain solution_pain_govern2 clearfix">
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/wenjianchuliza.png" alt="">
                                </div>
                                <p class="solution_block_text1">文件处理繁杂</p>
                                <p class="solution_block_text2">数量多，存储难，审批流程复杂</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/qianshuxiaolvdi.png" alt="">
                                </div>
                                <p class="solution_block_text1">签署效率低</p>
                                <p class="solution_block_text2">公众服务效率低，用户体验差</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/anquanyinhuangao.png" alt="">
                                </div>
                                <p class="solution_block_text1">安全隐患高</p>
                                <p class="solution_block_text2">涉密信息流转存在泄漏风险</p>
                            </div>
                        </div>
                        <div class="solution_blank_height"></div>
                        <h6 class="solution_title">解决方案</h6>
                        <p class="solution_intro">

                        </p>
                        <div class="solution_pain clearfix">
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/xianshangqianshu.png" alt="">
                                </div>
                                <p class="solution_block_text1">线上签署</p>
                                <p class="solution_block_text2">对接政府内系统，审批流程电子化</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/dianziguanli.png" alt="">
                                </div>
                                <p class="solution_block_text1">电子管理</p>
                                <p class="solution_block_text2">文件智能化管理，降低运营成本</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/datongshuju.png" alt="">
                                </div>
                                <p class="solution_block_text1">打通数据</p>
                                <p class="solution_block_text2">加强文件及数据流转能力</p>
                            </div>
                            <div class="solution_pain_block">
                                <div class="solution_block_img">
                                    <img src="@/assets/img/programme/jiamibaohu.png" alt="">
                                </div>
                                <p class="solution_block_text1">加密保护</p>
                                <p class="solution_block_text2">保障涉密信息安全，杜绝违法伪造</p>
                            </div>
                        </div>
                        <div class="solution_blank_height"></div>
                        <h6 class="solution_title">使用场景</h6>
                        <p class="solution_intro solution_intro_diff">

                        </p>
                        <div class="solution_chat">
                            <div class="solution_chat_block clearfix">
                                <div class="chat_block_left">
                                    <img src="@/assets/img/programme/icon_government.png" alt="">
                                    <p>政府</p>
                                </div>
                                <div class="chat_block_right">
                                    在政府内部线上办公系统中实现公文的在线签署与流转及审批
                                </div>
                            </div>
                            <div class="solution_chat_block solution_chat_block_diff clearfix">
                                <div class="chat_block_left">
                                    <img src="@/assets/img/programme/icon_person.png" alt="">
                                    <p>用户</p>
                                </div>
                                <div class="chat_block_right">
                                    个人及企业用户在窗口通过政务平台办理业务签署各种证明及协议。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "indusSolutionGovern"
    }
</script>

<style scoped>
    .top_banner{
        background-image: url(~@/assets/img/banner/indusSolutionGovern.png);
        background-size: 100% 100%;

    }
</style>